import { axios } from 'lib';
import { useQuery } from 'react-query';

const defaultQueryParams = {
  queryKey: ['consortium-group'],
  queryOptions: {},
};

const getConsortiumGroupById = async (faId, cgId) => {
  const { data } = await axios.get(`/api/framework_agreements/${faId}/consortium_groups/${cgId}`);

  return data;
};

export const useConsortiumGroup = (faId, cgId, queryParams = {}) => {
  const { queryKey, queryOptions } = {
    ...defaultQueryParams,
    ...queryParams,
  };

  return useQuery([...queryKey, cgId], () => getConsortiumGroupById(faId, cgId), {
    initialData: { cg_name: 'Consortium Group', FA: {} },
    ...queryOptions,
  });
};
